<template>
    <section class="products-by-category-wrap bg-gray mt-4 clearfix">
        <div class="container">
            <ProductGridSkeleton :quantity="6" :show-sub-categories="true" v-if="!fetchingProductsByCategory"></ProductGridSkeleton>
            <div v-else>
                <div v-if="data.category">
                    <div class="d-flex align-items-center justify-content-between mb-2" v-if="data.category">
                        <h2 class="section-title" v-html="data.category.name" :style="{ color: data.color }"></h2>
                        <a :href="data.category.url" class="view-all d-none d-md-block" :style="{ color: data.color }">
                            {{ $trans('ecommerce::layout.view_all') }}
                        </a>
                        <a :href="data.category.url" class="view-all d-md-none" :style="{ color: data.color }">
                            {{ $trans('ecommerce::layout.view_all') }}
                            <i class="las la-angle-right" aria-hidden="true"></i>
                        </a>
                    </div>

                    <div class="slick-slider" v-if="data.products">
                        <div class="products-by-category"  ref="productsByCategory">
                            <ProductCard v-for="product in data.products" :key="product.id" :product="product"/>
                        </div>
                    </div>

                    <div class="d-flex align-items-center justify-content-center" v-if="data.products.length == 0">
                        <div>
                            <img height="300" :src="iconEmptyUrl" alt="">
                            <div class="text-center">{{$trans('ecommerce::layout.no_data')}}</div>
                        </div>
                    </div>

                    <div class="row my-2 products-by-category-banner" v-if="isShowBanner">
                        <div class="col-6  pr-0 pr-md-2" v-if="data.banner_1.image.path">
                            <a :href="data.banner_1.call_to_action_url" class="banner" :target="data.banner_1.open_in_new_window? '_blank': '_self'">
                                <img class="d-none d-lg-block" :src="data.banner_1.image.path" alt="banner"/>
                            </a>
                        </div>

                        <div class="col-6 px-2 px-md-0" v-if="data.banner_2.image.path">
                            <a :href="data.banner_2.call_to_action_url" class="banner" :target="data.banner_2.open_in_new_window ? '_blank' : '_self'">
                                <img class="d-none d-lg-block" :src="data.banner_2.image.path" alt="banner"/>
                            </a>
                        </div>

                        <div class="col-6  pl-0 pl-md-2" v-if="data.banner_3.image.path">
                            <a :href="data.banner_3.call_to_action_url" class="banner" :target="data.banner_3.open_in_new_window ? '_blank' : '_self'">
                                <img class="d-none d-lg-block" :src="data.banner_3.image.path" alt="banner"/>
                            </a>
                        </div>
                    </div>

                      <div class="product-categories mt-2 d-flex align-items-center" v-if="data.category">
                        <div class="category-item" v-for="category in data.category.subCategories">
                            <a :href="category.url" v-html="category.name"></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import ProductCard from '../ProductCard.vue';
import ProductGridSkeleton from './SkeletonLoader/ProductGridSkeleton.vue';

export default {
    components: { ProductCard, ProductGridSkeleton },
    props: ['keySection'],
    data() {
        return {
            data: {
                'color': null,
                'banner_1': null,
                'banner_2': null,
                'banner_3': null,
                'products': [],
                'category': null,
            },
            fetchingProductsByCategory: false,
            isShowBanner: false,
        };
    },
    computed: {
          iconEmptyUrl() {
            return `${window.FleetCart.baseUrl}/themes/ecommerce/public/images/icon-empty.svg`;
        },
    },
    created() {
        $.ajax({
            method: 'GET',
            url: route('ecommerce.home.products_by_category.index', { 'key': this.keySection }),
        }).then((response) => {
            this.data = response;

            if (this.data.banner_1.image.path || this.data.banner_2.image.path || this.data.banner_3.image.path) {
                this.isShowBanner = true;
            }
            this.fetchingProductsByCategory = true;

              this.$nextTick(() => {
                $(this.$refs.productsByCategory).slick(this.slickOptions());
            });
        }).catch((xhr) => {
            this.fetchingProductsByCategory = false;
            this.$notify(xhr.responseJSON.message);
        });
    },

    methods: {
        slickOptions() {
            return {
                rows: 0,
                dots: false,
                arrows: true,
                infinite: false,
                slidesToShow: 6,
                slidesToScroll: 6,
                rtl: window.FleetCart.rtl,
                responsive: [
                    {
                        breakpoint: 1440,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll: 6,
                        },
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 5,
                        },
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        },
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            arrows: false,
                            slidesToShow: 1.9,
                            slidesToScroll: 1.9,
                        },
                    },
                ],
            };
        },
    },
};
</script>
